import { Route, Routes } from "react-router-dom";

import I1Positions from "./I1Positions/main";
import I1DownloadCenter from "./I1DownloadCenter/main";
import I1DataUpload from "./I1DataUpload/main";

export default function I1Routes() {
  return (
    <Routes>
      <Route path="i1_positions/*" element={<I1Positions />} />
      <Route path="i1_download_center/*" element={<I1DownloadCenter />} />
      <Route path="i1_data_upload/*" element={<I1DataUpload />} />
    </Routes>
  );
}
